export default class RemoveItem extends HTMLElement {
  constructor() {
    super();
    if (!this.toggle || !this.content) return;
    const self = this;
    this.state = new Proxy(
      {
        open: false,
      },
      {
        set(state, key, value) {
          const oldValue = state[key];

          state[key] = value;
          if (oldValue !== value) {
            self.processStateChange();
          }
          return state;
        },
      },
    );

    this.bindClick();
  }

  get toggle() {
    return this.querySelector("button[data-ref='toggle']");
  }

  get content() {
    return this.querySelector("[data-ref='content']");
  }

  get contentId() {
    return this.content.id;
  }

  get contentInner() {
    return this.querySelector("[data-ref='inner']");
  }

  get buttonFrame() {
    return this.querySelector("[data-ref='frame']");
  }

  processStateChange() {
    this.toggle.setAttribute("aria-expanded", this.state.open);
    this.content.classList.toggle("is-hidden", !this.state.open);
    const maxHeightKey = "--panel-max-height";
    this.content.style.setProperty(
      maxHeightKey,
      `${this.contentInner.scrollHeight}px`,
    );

    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
      { threshold: [1] },
    );
    observer.observe(this.buttonFrame);
  }

  bindClick() {
    this.toggle.setAttribute("aria-controls", this.content.id);
    this.toggle.addEventListener(
      "click",
      () => (this.state.open = !this.state.open),
    );
  }
}
